import { black, primary, textDark, textLight } from "../../../tokens/colors";

/*
  フッターの色。正本は tokens/colors.ts で、ここでは 16 進を直に書かない。
  字の対比は地に対して 4.5 以上 (明るい版は 地 black[75] に対し 見出し 10.7、リンクと著作 5.9、hover 4.5)
  light は SocialLinks など明るい面の部品が使う。PageFooter は全頁で dark に固定する
*/
export const FOOTER_COLORS = {
  light: {
    border: black[100],
    bg: black[75],
    head: textLight.main,
    link: black[600],
    hover: textLight.primary,
    copy: black[600],
  },
  dark: {
    /* 区切りの線。black[850] だと地 black[900] とほぼ同じで消えるので 700 にする */
    border: black[700],
    bg: black[900],
    head: textDark.main,
    link: textDark.sub,
    hover: primary[200],
    copy: textDark.sub,
    /* スマホの「よく使う 6 つ」の札の地。地 black[900] より一段明るい */
    tile: black[875],
  },
} as const;
